import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ClientService } from '@zaoblako/web/core/services/client/client.service';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'crm-client-deleting-modal',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent, ButtonComponent, SpinnerComponent],
  templateUrl: './client-deleting-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClientDeletingModalComponent implements OnInit {
  public loading = false;
  public client: ClientFindInterface;
  public clients: ClientFindInterface[] = [];
  public previousClientId: number;

  public constructor(
    public readonly ref: DynamicDialogRef,
    private readonly config: DynamicDialogConfig,
    private readonly clientService: ClientService,
    private readonly cdRef: ChangeDetectorRef
  ) {
    this.previousClientId = config.data.previousClientId;
  }

  public ngOnInit() {
    this.loading = true;
    this.cdRef.markForCheck();

    this.clientService.findAll().subscribe({
      next: (clients) => {
        this.clients = clients.filter((client) => client.id !== this.previousClientId);
        this.loading = false;
        this.cdRef.markForCheck();
      },
      error: () => {
        this.loading = false;
        this.cdRef.markForCheck();
      }
    });
  }
}
